'use strict'; // Get Icons

var brands = require('./icons/brands.json');

var solids = require('./icons/solids.json'); // Functions


var searchBrand = function searchBrand(label) {
  return brands.find(function (icon) {
    return icon.label.toLowerCase() === label.toLowerCase();
  });
};

var searchSolid = function searchSolid(label) {
  return solids.find(function (icon) {
    return icon.label.toLowerCase() === label.toLowerCase();
  });
}; // Export


module.exports = {
  searchBrand: searchBrand,
  searchSolid: searchSolid
};